<template>
  <div v-if="availableHotspots.length" class="product-settings-hotspots">
    <SelectionTiles
      v-slot="{ item }"
      :items="availableHotspots"
      :item-key="(hotspot) => hotspot.key"
      :item-selected="(hotspot) => hotspot.key === currentHotspot.key"
      :item-to-string="(item) => item.name"
      :min-item-width="130"
      :condensed="!displayHotspotImages"
      @change="selectHotspot"
    >
      <img
        v-if="displayHotspotImages"
        class="hotspot-image"
        :src="item.image"
      />
    </SelectionTiles>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import compositionCategoryHelper from 'commons/composition/compositionCategoryHelper';
import compositionHelper from 'commons/composition/compositionHelper';
import {
  HOTSPOTS_ORDERED,
  HOTSPOTS,
} from '@spreadgroup/common-partner-lib/states';
import { useStore } from 'vuex';
import SelectionTiles from 'src/app/components/selectionTiles/SelectionTiles.vue';
import {
  Composition,
  getAllProductTypes,
} from '@spreadgroup/common-partner-lib/composition';

const store = useStore();

const emit = defineEmits(['onDefaultSelect']);

const props = defineProps<{
  composition: Composition;
  selectedHotspot?: string;
  hotspots?: string[];
  displayHotspotImages?: boolean;
}>();

const productTypes = computed(() => {
  return getAllProductTypes(store.state.publishingCore.categories);
});

const availableHotspots = computed(() => {
  const hotspots =
    props.hotspots ||
    compositionCategoryHelper.getAllAvailableHotspots(productTypes.value);
  return HOTSPOTS_ORDERED.filter((hotspot) => hotspots.includes(hotspot.key));
});
const currentHotspot = computed(() => {
  const hotspotKey =
    props.selectedHotspot ||
    compositionHelper.getDefaultHotspot(props.composition);
  return HOTSPOTS[hotspotKey as keyof typeof HOTSPOTS];
});
const selectHotspot = (hotspot: { key: string }) => {
  emit('onDefaultSelect', hotspot.key);
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/links';

.hotspot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 100px;

  span {
    text-align: center;
  }
}

.hotspot-image {
  width: 100%;
}
</style>
